import { z } from "zod";

import { ORDER_ACTION_VALUES, ORDER_DIRECTION_VALUES, ORDER_STATUS_VALUES, valueMap } from "../platform/domain-values";

export { ORDER_DIRECTION_VALUES, ORDER_STATUS_VALUES };

export const orderStatusSchema = z.enum(ORDER_STATUS_VALUES);
export type OrderStatus = z.infer<typeof orderStatusSchema>;
export const ORDER_STATUSES = valueMap(ORDER_STATUS_VALUES);

export const ORDER_STATUS_LABELS: Record<OrderStatus, string> = {
  requested: "Requested",
  ordered: "Ordered",
  fulfilled: "Fulfilled",
  cancelled: "Cancelled",
};

export function isOrderStatus(status: string): status is OrderStatus {
  return orderStatusSchema.safeParse(status).success;
}

export function getOrderStatusLabel(status: OrderStatus): string {
  return ORDER_STATUS_LABELS[status];
}

export const orderDirectionSchema = z.enum(ORDER_DIRECTION_VALUES);
export type OrderDirection = z.infer<typeof orderDirectionSchema>;
export const ORDER_DIRECTIONS = valueMap(ORDER_DIRECTION_VALUES);

export const ORDER_ACTIONS = valueMap(ORDER_ACTION_VALUES);
export type OrderAction = typeof ORDER_ACTION_VALUES[number];

export function isOrderDirection(value: string): value is OrderDirection {
  return orderDirectionSchema.safeParse(value).success;
}
